import { Controller } from '@hotwired/stimulus';

// État de la bouteille choisi sur une image (TankStateComponent) : fenêtre de
// choix (outlet dialog), refermée par un clic sur une image (au clavier, les
// flèches parcourent les images, « Fermer » ou Échap referme) ; état choisi
// affiché, NOK au-delà de `nokAbove` ; « Réinitialiser » décoche les images
// (le champ caché garde la valeur de départ `initial`).
export default class extends Controller {
    static targets = ['label'];
    static values = { nokAbove: Number, initial: String };
    static outlets = ['dialog'];

    connect() {
        this.render();
    }

    open() {
        this.dialogOutlet.open();
    }

    chosen(event) {
        if (event.detail > 0) this.dialogOutlet.close();
    }

    reset() {
        this.element.querySelectorAll('input[type="radio"]').forEach((radio) => { radio.checked = false; });
        this.dialogOutlet.close();
        this.element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    render() {
        const choice = this.element.querySelector('input[type="radio"]:checked');
        const label = this.labelTarget;
        label.classList.remove('bg-ok', 'bg-ko', 'text-white', 'text-muted');
        if (!choice) {
            label.textContent = this.initialValue === 'na' ? 'Non applicable' : 'Non renseigné';
            label.classList.add('text-muted');
            return;
        }
        const nok = Number(choice.value) > this.nokAboveValue;
        label.textContent = `État ${choice.value} · ${nok ? 'NOK' : 'OK'}`;
        label.classList.add(nok ? 'bg-ko' : 'bg-ok', 'text-white');
    }
}
